import style from './style.module.css';

const AppContainer = ({ children, primaryColor = "#3271f5" }) => <div style={{ '--primary-color': primaryColor }} className={style.container}>{children}</div>;

export default AppContainer;
